import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faMap } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, Tickets, MapPin, Info } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from '../common/function';
import { changeAlramModal, checkDuplicateLogins } from '../../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
import { SyncLoader } from "react-spinners";
import FallbackImage from '../common/FallbackImage';
import Coupons_Footer from '../common/coupons_footer';

function CategoriesList_Soda() {
    const { t } = useTranslation();

    const myData = useSelector((state) => state.myData);
    const mySkin = useSelector((state) => state.mySkin);
    const JWT = useSelector((state) => state.JWT.value);

    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [totalList, setTotalList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalData, setTotalData] = useState(0)
    const [maxFirstCnt, setMaxFirstCnt] = useState(20)
    const [listSpinner, setListSpinner] = useState(true)

    const dispatch = useDispatch();
    const navigate = useNavigate(); // 라우터 이동을 위해 사용
    const location = useLocation();

    const categoriesData = location?.state?.types ?? []
    const brandsData = location?.state?.brands ?? []

    const handleSelectCoupon = (coupon) => {
        navigate(`/shoppingDetail/${coupon.ci_goods_no}`, {
            state: { item: coupon },
        });
    };

    useEffect(() => {
        CategoryData();
    }, []);

    useEffect(() => {
        if (page === 1) setListSpinner(true)
        ListData()
    }, [categoriesData, page]);

    const CategoryData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/sodagift/coupon/user/coupon-categories',
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data?.data ?? [];

            setCategories(tmp?.types ?? [])
            setBrands(
                tmp?.brands.filter((item) => {
                    const assoc = item.pc_associated_category_names;
                    const target = categoriesData?.pc_category_name;
                    if (Array.isArray(assoc)) {
                        return assoc.includes(target);
                    }
                    if (typeof assoc === 'string') {
                        return assoc.includes(target);
                    }
                    return false;
                }) ?? []
            );
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const ListData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", page.toString());
            params.append("take", maxFirstCnt);
            params.append("coupon_type", categoriesData?.pc_category_name ?? "");
            params.append("brand", "");
            params.append("sort_price", "");

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/sodagift/coupon/user/coupon-products',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data ?? [];
            console.log(tmp);
            setTotalList((prev) => [...prev, ...tmp?.data ?? []]);
            setTotalData(tmp?.total ?? 0)
            setListSpinner(false)
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const observerRef = useRef(null);
    useEffect(() => {
        if (totalList.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalData > page * maxFirstCnt) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [totalList]);

    const [brandIndex, setBrandIndex] = useState(0);

    const handleBrandScroll = (e) => {
        const scrollLeft = e.target.scrollLeft;
        const width = e.target.clientWidth;
        const index = Math.round(scrollLeft / width);
        setBrandIndex(index);
    };

    return (
        <div
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative",
                color: "#000"
            }}
        >
            <div style={{ padding: '0px', paddingBottom: '60px', fontFamily: 'sans-serif' }}>
                {/* 고정된 상단 헤더 */}
                <div
                    style={{
                        position: 'fixed',
                        top: "0px",
                        left: "0px",
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: "50px",
                        background: "#fff",
                        padding: "0 15px",
                        zIndex: "10",
                    }}
                >
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });
                            navigate(-1)
                        }}
                    >
                        <ChevronLeft style={{ width: '30px', height: '30px' }} />
                    </div>
                    <div style={{ fontWeight: 'bold', color: "#000", fontSize: "18px" }}>
                        {categoriesData?.pc_category_name ?? t('shopping_15')}
                    </div>
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });
                            navigate('/shopping')
                        }}
                    >
                        <X style={{ width: '28px', height: '28px' }} />
                    </div>
                </div>
                <div style={{ height: "140px", marginTop: "50px" }}>
                    <>
                        <div
                            className="brand-slide-wrapper"
                            onScroll={handleBrandScroll}
                        >
                            {Array.from({ length: Math.ceil(brands.length / 4) }).map((_, i) => {
                                const group = brands.slice(i * 4, i * 4 + 4);
                                const padded = [...group, ...Array(4 - group.length).fill(null)];
                                return (
                                    <div key={i} className="brand-list-slide">
                                        {padded.map((brand, idx) => (
                                            <div key={idx} className="brand-card" onClick={() => navigate('/brandsList', { state: { brands: brand, types: categoriesData } })}>
                                                {brand ? (
                                                    <>
                                                        <FallbackImage
                                                            src={brand?.pc_category_custom_img ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${brand?.pc_category_custom_img}` : brand?.pc_category_img}
                                                        />
                                                        <div>
                                                            <div className="brand-label">{brand.pc_category_name}</div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div style={{ height: 58 }}></div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                        <div className="slide-indicator" style={{ marginTop: "0" }}>
                            {Array.from({ length: Math.ceil(brands.length / 4) }).map((_, i) => (
                                <div key={i} className={`slide-dot ${brandIndex === i ? 'active' : ''}`} />
                            ))}
                        </div>
                    </>
                </div>

                <div style={{ padding: "15px", background: "#fff", minHeight: "calc(100dvh - 250px)" }}>
                    {
                        listSpinner
                            ?
                            <div style={{ marginTop: "100px" }}>
                                <SyncLoader
                                    color="#ffbb3f"
                                    size={10}
                                    cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                                    speedMultiplier={1}
                                />
                            </div>
                            :
                            totalList?.length > 0
                                ?
                                <div className="coupons-grid" style={{ paddingBottom: "0" }}>
                                    {totalList.map((item, idx) => (
                                        <div
                                            key={idx}
                                            className="coupon-item"
                                            onClick={() => handleSelectCoupon(item)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div
                                                className={`coupon-image-wrapper`}
                                                style={{ position: 'relative' }}
                                            >
                                                <FallbackImage
                                                    src={item?.ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${item.ci_custom_image_filename}` : item.ci_goods_img_big}
                                                    className="coupon-image"
                                                    style={{ border: "1px solid #f9f9f9" }}
                                                />
                                            </div>

                                            <div
                                                style={{
                                                    padding: '0px 0 10px',
                                                    textAlign: "left",
                                                    fontSize: "14px",
                                                    background: "#fff",
                                                    marginTop: "5px"
                                                }}
                                            >
                                                <div
                                                    className="table-overflow-1line"
                                                    style={{ color: "gray", fontWeight: "500", fontSize: "13px" }}
                                                >
                                                    {item.ci_brand_name}
                                                </div>
                                                <div
                                                    className="table-overflow-2lines"
                                                    style={{ color: '#000', marginBottom: "4px" }}
                                                >
                                                    {item.ci_goods_name}
                                                </div>
                                                <div style={{ color: '#000', fontWeight: "bold" }}>
                                                    {changeNum(item.ci_point_price)}p
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div ref={observerRef} style={{ height: '1px' }}></div>
                                </div>
                                :
                                <div style={{ width: "100%", margin: "30px 0" }}>
                                    <img src={`${process.env.REACT_APP_API}${mySkin.skin_img}`} style={{ width: "150px", marginBottom: "10px" }} />
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#000" }}>{t('shopping_9')}</div>
                                </div>
                    }
                </div>
                <Coupons_Footer />
            </div>
        </div>
    );
}

export default CategoriesList_Soda;